import React, { useState } from 'react';
import PropTypes from 'prop-types';
// Material-UI
import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
// Icons
import { X } from 'tabler-icons-react';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
// Context
import { useCuenta } from './CuentaContext';
import { useGeneral } from '../../Context/GeneralContext';

export default function CambiarPass({ open, onClose }) {
    const { userName } = useCuenta();
    const { tokenR } = useGeneral();

    const [phase, setPhase] = useState(1);
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPass, setShowPass] = useState(false);
    const [passwordError, setPasswordError] = useState(false);

    const handleClose = () => {
        setPhase(1);
        setNewPassword(''); setConfirmPassword('');
        setShowPass(false); setPasswordError(false);
        onClose();
    };

    const confirmNewPassword = () => {
        if (!newPassword.trim()) { setPasswordError(true); return; }
        setPasswordError(false);
        setPhase(2);
    };

    const savePassword = async () => {
        try {
            const res = await fetch(
                `${process.env.REACT_APP_SERVICE_ENDPOINT}/usuarios/restaurarcontrasena`,
                {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json', authorization: `Bearer ${tokenR.current}` },
                    body: JSON.stringify({ usuario: userName, password: newPassword }),
                }
            );
            if (!res.ok) throw new Error('Error al cambiar contraseña');
            setNewPassword(''); setConfirmPassword('');
            setPhase(3);
        } catch (err) {
            console.error(err);
        }
    };

    const titles = { 1: 'Cambiar contraseña', 2: 'Confirmar cambio', 3: 'Contraseña actualizada' };

    const eyeAdornment = (
        <InputAdornment position="end">
            <IconButton size="small" onClick={() => setShowPass(p => !p)}>
                {showPass ? <VisibilityOff /> : <Visibility />}
            </IconButton>
        </InputAdornment>
    );

    const renderBody = () => {
        switch (phase) {
            case 1:
                return (
                    <>
                        <div className="cuenta-modal-body">
                            <TextField
                                label="Contraseña"
                                type={showPass ? 'text' : 'password'}
                                value={newPassword}
                                onChange={e => { setNewPassword(e.target.value); if (passwordError && e.target.value.trim()) setPasswordError(false); }}
                                fullWidth
                                error={passwordError}
                                helperText={passwordError ? 'Debe completar el campo' : ''}
                                InputProps={{ endAdornment: eyeAdornment }}
                            />
                            <TextField
                                label="Confirmar contraseña"
                                type={showPass ? 'text' : 'password'}
                                value={confirmPassword}
                                onChange={e => setConfirmPassword(e.target.value)}
                                fullWidth
                                error={confirmPassword.length > 0 && confirmPassword !== newPassword}
                                helperText={confirmPassword.length > 0 && confirmPassword !== newPassword ? 'Las contraseñas no coinciden' : ''}
                                InputProps={{ endAdornment: eyeAdornment }}
                            />
                        </div>
                        <div className="cuenta-modal-footer">
                            <Button variant="outlined" className="cuenta-modal-cancel" onClick={handleClose}>Cancelar</Button>
                            <Button
                                variant="contained" color="primary" className="cuenta-modal-submit"
                                onClick={confirmNewPassword}
                                disabled={!newPassword || !confirmPassword || newPassword !== confirmPassword}
                            >
                                Continuar
                            </Button>
                        </div>
                    </>
                );
            case 2:
                return (
                    <>
                        <div className="cuenta-modal-body cuenta-modal-body--confirm">
                            <p className="cuenta-confirm-text">
                                ¿Estás seguro de que deseas cambiar tu contraseña?
                            </p>
                        </div>
                        <div className="cuenta-modal-footer">
                            <Button variant="outlined" className="cuenta-modal-cancel" onClick={() => setPhase(1)}>Volver</Button>
                            <Button variant="contained" color="primary" className="cuenta-modal-submit" onClick={savePassword}>
                                Guardar contraseña
                            </Button>
                        </div>
                    </>
                );
            case 3:
                return (
                    <>
                        <div className="cuenta-modal-body cuenta-modal-body--success">
                            <CheckCircleOutlineIcon className="cuenta-success-icon" />
                            <p className="cuenta-success-title">¡Contraseña actualizada!</p>
                            <p className="cuenta-success-subtitle">Ya puedes iniciar sesión con tu nueva contraseña.</p>
                        </div>
                        <div className="cuenta-modal-footer">
                            <Button variant="contained" color="primary" className="cuenta-modal-submit" onClick={handleClose}>
                                Cerrar
                            </Button>
                        </div>
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <div className="cuenta-modal">
                <div className="cuenta-modal-header">
                    <h2 className="cuenta-modal-title">{titles[phase]}</h2>
                    <IconButton size="small" onClick={handleClose}><X size={18} strokeWidth={2} /></IconButton>
                </div>
                {renderBody()}
            </div>
        </Modal>
    );
}

CambiarPass.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};
